import { z } from 'zod'

export const countryCodeSchema = z.string().default('US')
export type CountryCode = z.infer<typeof countryCodeSchema>

export const creativeSchema = z.object({
  advertiser: z.string(),
  placement: z.string(),
  campaign: z.string(),
  creativeName: z.string(),
  imageUrl: z.string().url(),
  headline: z.string(),
  brand: z.string(),
  clickUrl: z.string().url(),
  shouldOpenInDefaultBrowser: z.boolean().default(false).optional(),
  shouldOpenInCurrentBrowser: z.boolean().default(true).optional(),
})
export type Creative = z.infer<typeof creativeSchema>

const positionSchema = z.object({
  placement: z.string(),
  section: z.union([z.literal(0), z.literal(1)]),
  x: z.number(),
  y: z.number(),
})

export const directAdsFlightSchema = z.object({
  campaignStartTime: z.number(),
  campaignEndTime: z.number(),
  position: positionSchema,
  splitPercentage: z.number().min(0).max(100),
  shouldOpenInDefaultBrowser: z.boolean().default(false),
  shouldOpenInCurrentBrowser: z.boolean().default(true).optional(),
  creatives: z.array(creativeSchema),
})
export type DirectAdsFlight = z.infer<typeof directAdsFlightSchema>

export const directAdsConfigSchema = z.record(
  countryCodeSchema,
  z.array(directAdsFlightSchema)
)
export type DirectAdsConfig = z.infer<typeof directAdsConfigSchema>
